import React, { memo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import classNames from 'classnames';

import { useOverlayState } from '../../../hooks/useOverlayState';

import { statusBadge } from '../../../constants/statuses';

import EditLineIcon from '../../../design-system/Icons/EditLineIcon';
import TimestampDisplay from '../../../design-system/TimestampDisplay/TimestampDisplay';
import ArchiveCycleModal from '../CycleDetailPage/ArchiveCycleModal/ArchiveCycleModal';
import { Badge, ButtonIcon } from '../../../design-system';
import { DeleteBin4LineIcon, LoopRightFillIcon } from '../../../design-system/Icons';

const CycleCard = ({ cycle, keysToMutate }) => {
    const { id, name, current_stage, created_at } = cycle;
    const { name: stageName, stage_status } = current_stage || {};
    const { status_label, status_color } = stage_status || {};

    const navigate = useNavigate();
    const location = useLocation();

    const { isOpened, open: openArchiveModal, close: closeArchiveModal } = useOverlayState();

    const cardContainerClassName = classNames(
        'px-4 py-3 max-w-full w-full rounded-2 bg-white',
        'grid grid-rows-[auto_auto_auto] md:grid-rows-[auto_auto] lg:grid-rows-1 grid-cols-[23px_minmax(100px,_1fr)_62px] md:grid-cols-[23px_minmax(100px,_1fr)_minmax(100px,_1.1fr)_62px] lg:grid-cols-[23px_minmax(100px,_1.15fr)_minmax(100px,_1fr)_146px_62px] xl:grid-cols-[23px_minmax(100px,_1.2fr)_minmax(100px,_1fr)_154px_62px] 3xl:grid-cols-[23px_minmax(100px,_1.2fr)_minmax(100px,_1fr)_168px_62px] gap-x-3 xl:gap-x-4 gap-y-1 items-center'
    );

    return (
        <div className={cardContainerClassName}>
            <div className="w-[23px] min-w-[23px] h-[28px] flex items-center justify-center">
                <LoopRightFillIcon width={15} height={15} color="#000000" />
            </div>
            <p className="font-body-bold text-body-bold-xs text-neutral-500 truncate">{name}</p>

            <div className="col-span-full row-start-2 row-end-2 md:row-start-auto md:row-end-auto md:col-span-1 flex items-center justify-between gap-4">
                <p className="font-body text-body-regular-xs text-neutral-500 whitespace-nowrap truncate">
                    Stage:{' '}
                    <span className="font-body-bold text-body-bold-xs whitespace-nowrap truncate">
                        {stageName}
                    </span>
                </p>

                <Badge text={status_label} color={status_color} />
            </div>

            <div className="lg:justify-items-center pt-2 lg:p-0 border-t-1 border-neutral-200 lg:border-none row-start-3 row-end-3 col-span-full md:row-start-2 md:row-end-2 lg:row-start-auto lg:row-end-auto lg:col-span-1">
                <TimestampDisplay
                    label="Created At"
                    timestamp={created_at}
                    dateTimeFormat="MM/dd/yyyy"
                />
            </div>

            <div className="flex items-center justify-end md:gap-1.5">
                <ButtonIcon
                    type="link"
                    size="xs"
                    icon={EditLineIcon}
                    onClick={() =>
                        navigate(`/configure/cycle/${id}`, { state: { from: location } })
                    }
                />
                <ButtonIcon
                    type="link"
                    size="xs"
                    icon={DeleteBin4LineIcon}
                    onClick={openArchiveModal}
                />
            </div>

            {isOpened && (
                <ArchiveCycleModal
                    id={id}
                    name={name}
                    requestKeysToMutate={keysToMutate}
                    onClose={closeArchiveModal}
                />
            )}
        </div>
    );
};

export default memo(CycleCard);
